<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Documents</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="addButton" (click)="onAddDocumentClick()">
                <ion-icon name="add"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="ion-text-wrap">
        {{documents.length}} documents defined. Click + to add a new document or tap to edit.
    </ion-list-header>
    
    <ion-list class="ion-padding">
        @for (document of documents; track $index) {
  <ion-item-sliding>
            <ion-item detail="true" (click)="onDocumentClick(document.uid)">
                <div>
                    <strong>{{document.documentName}}</strong><br />
                    {{document.domain}}
                </div>
            </ion-item>
            <ion-item-options>
                <ion-button data-test="deleteButton" danger (click)="confirmDeleteDocument(document)">
                    <ion-icon name="trash">Delete</ion-icon>
                </ion-button>
            </ion-item-options>
        </ion-item-sliding>
}
    </ion-list>
</ion-content>